<template>
 <div id="app">
  <el-container>
   <el-header class="div-header">
    <Header />
    <el-divider class="header-divider"></el-divider>
   </el-header>

   <div class="main-div">
    <el-container class="main-div parentDiv">
     <splitpanes class="default-theme defaultStyle custom-splite">
      <pane size="100" class="SideBarLeft">
       <!--SID1005 Body Part-->
       <template>
        <el-container class="SID1005__ThemeGroupRegistrationScreen">
         <div class="SID1005__Container">
          <!-- Breadcrumb section -->
          <el-breadcrumb separator-class="el-icon-arrow-right">
           <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧) </el-breadcrumb-item>
           <el-breadcrumb-item :to="{ path: '1004' }">テーマグループ一覧</el-breadcrumb-item>
           <el-breadcrumb-item :to="{ path: '' }">テーマグループ登録</el-breadcrumb-item>
          </el-breadcrumb>
          <el-form
           ref="ruleForm"
           :rules="rules"
           :model="ruleForm"
           label-width="auto"
          >
           <el-form-item prop="getname_id" label="テーマグループ名 ">
            <el-input
             v-model="ruleForm.getname_id"
             value=""
			class="input1005"
			@keypress="isNumber"
            ></el-input>
           </el-form-item>
           <el-form-item>
			<!-- // 2023/03/27  #14161  START -->
            <el-button
             type="primary"
             plain
             @click="
              add('ruleForm');              
             "
			 :disabled="Buttonpressed == 1"
             >登録</el-button
            >
			<!-- // 2023/03/27  #14161  END -->
            <el-button type="info" plain @click="redirectTo1004"
             >戻る</el-button
            >
           </el-form-item>
          </el-form>
          <el-row>
           <el-col :span="12">
            <div class="userSettingSpan">
             <span><span class="customStar">*</span>テーマ名設定</span>
            </div>
            <div class="TopicInfoRegister">
             <el-table
              class="tabletop"
              ref="multipleTable"
              :data="getEditTheme"
              border
			@selection-change="handleSelectionChangeLeft"		
              style="width: 100%"
             >
              <el-table-column  type="selection">
              </el-table-column>
              <el-table-column
               label="テーマ番号"
               width="100"
               property="theme_id"
              >
              </el-table-column>
              <el-table-column
               property="theme_name"
               label="テーマ名"
               min-width="350"
              >
              </el-table-column>
             </el-table>
            </div>
           </el-col>
           <el-col :span="11" :offset="1">
            <div class="userSettingSpan">
             <span>ユーザグループID設定</span>
            </div>
            <div class="TopicInfoRegister">
             <el-table
              class="tableBottom"
              ref="multipleTable1"
				:data="getEditUser"
              border
			@selection-change="handleSelectionChangeRight"	
              style="width: 100%"
             >
              <el-table-column type="selection"  >
              </el-table-column>
              <el-table-column
               label="ユーザグループID"
               min-width="300"
               property="user_group_name"
              >
              </el-table-column>
              <el-table-column
               property="user_count"
               label="ユーザ数"
               width="100"
              >
              </el-table-column>
             </el-table>
            </div>
           </el-col>
          </el-row>
         </div>
        </el-container>
       </template>
       <!--SID1005 Body Part End-->
      </pane>

      <pane class="SideBarRight">
       <SideBar class="SidePane" />
      </pane>
     </splitpanes>
    </el-container>
   </div>

   <el-container class="footer-div">
    <el-footer class="footer-element">
     <FooterComponent />
    </el-footer>
   </el-container>
  </el-container>
 </div>
</template>


<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from '../../router';
import json from '../../components/config.json';
import jsonConst from '../../common/CommonConst.json'
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import common_json from "../../common/CommonConst.json";
export default {
	name: "app",
	
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
		var confirmLengthTwenty = (rule, value, callback) => {
		var passCheckLength= this.ruleForm.getname_id ;
            if (passCheckLength.length > 20) {
              callback(new Error('Enter confirm 20 char of password'));
            } 
            else {
              callback();
            }
		};
		return {
			// 2023/03/27  #14161  START
			Buttonpressed: 0,
			// 2023/03/27  #14161  END
			ruleForm:{
				getname_id : ''
			},
			rules: {
				getname_id: [
					{ required: true,type:"string", message: 'テーマグループ名を入力してください。'},
					/*** Change by BM for backlog Id: 1641 to remove  half-width and full-width symbols from the pattern and reverted*/
					/***2021/04/20  #10821  START*/
					//{  required: true,pattern: /^[^-,^/,^|,^$,^+,^%,^&,^',^(,^),^*,^\x20-\x2f,^\x3a-\x40,^\x5b-\x60,^\x7b-\x7e,^\x80-\xff]+$/, message: 'テーマグループ名は記号以外を入力してください。'},
					{  required: true,pattern: /^[\u2000-\u206f\u2600-\u26ff\u2000-\u206f\u25a0-\u25ff\u3000-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff00-\uffeea-zA-Z0-9]+$/, message: 'テーマグループ名は記号以外を入力してください。'},
					/***2021/04/20  #10821  END*/
					{  validator: confirmLengthTwenty, message: 'テーマグループ名は20文字以下を入力してください。'}
					
					],
			},
			getname_id : '',
			themegroudid : '',
			multipleSelection: [],
			multipleSelection1: [],

		};
	},
	methods: {
		isNumber(evt){
			evt = (evt) ? evt : window.event; var charCode = (evt.which) ? evt.which : evt.keyCode; if (charCode > 31 && (charCode < 48 || charCode > 57)) { return false; } return true;

		},
		// For checkbox multiple selection of the theme List
		handleSelectionChangeLeft(val){
			this.multipleSelection =  val;
		},

		// For checkbox multiple selection of the User List
		handleSelectionChangeRight(val){
			this.multipleSelection1 =  val;
			
		},
		// while editing 
		toggleSelectionRight(rows) {
			if(rows){
				for(let i=0; i<rows.length; i++){
					
					if(rows[i].checked_status == true){
						this.$refs.multipleTable1.toggleRowSelection(rows[i]);
					
					}
				} 			
			}else {
				//this.$refs.multipleTable.clearSelection();
			}
		},
		
		toggleSelectionLeft(rows) {
			if(rows){
				for(let i=0; i<rows.length; i++){
					
					if(rows[i].checked_status == true){
						this.$refs.multipleTable.toggleRowSelection(rows[i]);
					}
				} 
			}else {
				//this.$refs.multipleTable.clearSelection();
			}
		},
		toggleSelectionRightall(rows) {
			
				for(let i=0; i<rows.length; i++){
					
						this.$refs.multipleTable1.toggleRowSelection(rows[i]);
					
					
				}
			
		},
		//For new theme
	add(formName) {
		this.$LogButtonEvent("1005","Registration");
		this.$LogMethodIN("1005","add");
		this.$refs[formName].validate((valid) => {
		if (valid) {
			if (this.$refs.multipleTable.selection.length == 0) {
				this.$alert(json["1005_checkbox_not_check_message_title"], json["1005_checkbox_not_check_message"], {
					confirmButtonText: 'OK'
				});
				return false;
			}
			// 2023/03/27  #14161  START
			this.Buttonpressed= 1;
			// 2023/03/27  #14161  END
			var theme_idArray = [];
			var arrayLength = this.$refs.multipleTable.selection.length;
			for (var i = 0; i < arrayLength; i++) {
				theme_idArray.push((this.$refs.multipleTable.selection[i].theme_id));
			}
			var group_idArray = [];
			var arrayLengthUser = this.$refs.multipleTable1.selection.length;

			for (var j = 0; j < arrayLengthUser; j++) {
				group_idArray.push((this.$refs.multipleTable1.selection[j].user_group_id));
			}

			var formCredentials = {};

			if(this.$route.params.Details == undefined){
				// send paramertes for the Adding the data's without theme_group_id

				formCredentials = {
				contract_id: jsonConst['contract_id'],
				theme_group_name: this.ruleForm.getname_id,
				theme_id: theme_idArray,
				user_group_id: group_idArray
			};
			this.$store.dispatch('communication1005/passFormDetails', formCredentials).then(() => {
				this.$alert(this.getMsgDetails, json["1005_register_success_title"], {
					confirmButtonText: 'OK'
				});
				// 2023/03/27  #14161  START
                this.Buttonpressed= 0;
                // 2023/03/27  #14161  END
				common_json["redirect_path"] = '1004';
				router.push({name:"1004"});
			});
		}else{
			// send paramertes for the Editing the data's with selected theme_group_id
			// 2023/03/27  #14161  START
			this.Buttonpressed= 1;
			// 2023/03/27  #14161  END
			formCredentials = {
				contract_id: jsonConst['contract_id'],
				theme_group_id : this.$route.params.Details.theme_group_id,
				theme_group_name: this.ruleForm.getname_id,
				theme_id: theme_idArray,
				user_group_id: group_idArray
			};
			this.$store.dispatch('communication1005/passFormDetails', formCredentials).then(() => {
				this.$alert(this.getMsgDetails, json["1005_update_success_title"], {
					confirmButtonText: 'OK'
				});
				common_json["redirect_path"] = '1004';
				router.push({name:"1004"});
			});
			// 2023/03/27  #14161  START
			this.Buttonpressed= 0;
			// 2023/03/27  #14161  END
		}
	} else {
		return false;
	}
	});
		this.$LogMethodOut("1005","add");
	},
	//Gets called when the user clicks on the 戻る button
	redirectTo1004() {
		this.$LogButtonEvent("1005","Return");
		this.$LogMethodIN("1005","redirectTo1004");
		common_json["redirect_path"] = '1004';
		router.push({
			name: "1004"
		});
		this.$LogMethodOut("1005","redirectTo1004");
	},

},
	computed: {
	
	...mapGetters("situation1005", [
		"getTableResult1005",
		"getTableResult21005",
		"getcheck",
		"getEditTheme1",
		"getname",
		"getEditTheme",
		"getEditUser",
		"getEditgroupName",
		"getIsEditFlag",
		"getUpdateTheme",
		"getUpdateUser",
		"getUpdategroupName",
		"getjson",
		"getruleform",
		"gettheme_group_id",
		"getMsgDetails"


	]),
	...mapGetters("situation0001", [
      
			"getThemeBrowsing"
		])

},
 //called after all the DOM elements has been mounted
mounted() {
	if(this.$route.params.Details == undefined || this.$route.params.Details == ""){
		this.$store.dispatch('communication1005/getTableData').then(() => {
		
		if(this.getThemeBrowsing == false){
		
			this.$nextTick(function(){

			this.toggleSelectionRightall(this.getEditUser);
			});
		}
		
			
	});
	
	}
	else{
		this.ruleForm.getname_id = this.$route.params.Details.theme_group_name;
		this.$nextTick(function(){
			this.toggleSelectionLeft(this.getEditTheme);
		});

		this.$nextTick(function(){
			this.toggleSelectionRight(this.getEditUser);
		});
		
	}
	
	
},

	
	beforeCreate(){
		//For the screen Title
     document.title = "テーマグループ一覧画面";
		common_json["redirect_path"] = '1005';
	},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import "1005.css"
</style>